/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2024 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers.  The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

type Widget = {
    widgetId: string;
    analyticsObject: {};
};

type WidgetsCoveoState = Readonly<{
    widgets: Widget[];
}>;

const initialModalState: WidgetsCoveoState = {
    widgets: [],
};

const reducer = {
    "xWidgetsCoveo/SetWidgetIdAndData": (draft: Draft<WidgetsCoveoState>, action: { widgetId: string, analyticsObject: {} }) => {
        const index = draft.widgets.findIndex(widget => widget.widgetId === action.widgetId);
        if (index !== -1) {
            draft.widgets[index] = {
                widgetId: action.widgetId,
                analyticsObject: action.analyticsObject,
            };
        } else {
            draft.widgets.push({
                widgetId: action.widgetId,
                analyticsObject: action.analyticsObject,
            });
        }
    },
};

const WidgetsCoveo = createTypedReducerWithImmer(initialModalState, reducer);

(reducers as any).WidgetsCoveo = WidgetsCoveo;

export type widgetsCoveoState = {
    WidgetsCoveo: WidgetsCoveoState;
};

type widgetsCoveoReducers = {
    widgets: typeof WidgetsCoveo;
};

export type widgetsCoveoActions =
    | Parameters<widgetsCoveoReducers[keyof widgetsCoveoReducers]>[1]
    | AnyAction;
